import React from "react";

const ShareIcon = () => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.875 6.25001H17.6172L11.4453 1.13282C11.1719 0.898443 11.1719 0.507818 11.3672 0.234381C11.6016 -0.0390568 11.9922 -0.0390568 12.2656 0.156256L19.7656 6.36719C19.8828 6.52344 20 6.71876 20 6.87501C20 7.03126 19.8828 7.22657 19.7656 7.34376L12.2656 13.5547C12.1484 13.6328 11.9922 13.7109 11.875 13.7109C11.6797 13.7109 11.4844 13.6328 11.3672 13.4766C11.1719 13.2031 11.1719 12.8125 11.4453 12.5781L17.6172 7.46094H6.875C3.75 7.46094 1.25 9.96094 1.25 13.0469V14.2578C1.25 14.7266 0.9375 15 0.625 15C0.273438 15 0 14.7266 0 14.375V13.1641C0 9.33594 3.04688 6.25001 6.875 6.25001Z"
        fill="black"
      />
    </svg>
  );
};

export default ShareIcon;
